
import { getCountryByCode } from 'libs/geographicalRegion';
import getCountry from 'getcountry';
import getCountryISO2 from 'country-iso-3-to-2';
import { getUserCountryFromUrl } from 'libs/auth';

export function fetchLocationApi() {
  return new Promise((resolve) => {
    function getDefaultLocation() {
      const countryCode = getUserCountryFromUrl();
      const country = getCountryByCode(countryCode) || {};
      const countryName = Object.keys(country)[0];
      let defaultLocation = {
        countryCode: 'US',
        countryName: 'United States'
      };
      if (countryName) {
        defaultLocation = { countryCode, countryName };
      }
      resolve(defaultLocation);
    }

    getCountry({
      errorHandler: getDefaultLocation
    })
      .then((countryCodeAlpha3) => {
        const countryCodeAlpha2 = getCountryISO2(countryCodeAlpha3);
        const country = getCountryByCode(countryCodeAlpha2);
        const countryName = Object.keys(country)[0];
        resolve({ countryCode: countryCodeAlpha2, countryName });
      })
      .catch(getDefaultLocation);
  });
}

export default {
  fetchLocationApi
};



// WEBPACK FOOTER //
// ./src/api/location.js